import React from "react";
import PropTypes from "prop-types";
import "./Filters.scss";
import {Button} from "@datassential/platform-ui-lib";

const Filters = (
    {
        filtersArray = [],
        applyFilters = null,
        resetFilters = null,
        toggleFilter,
        isApplyButtonHighlighted = false,
    }
) => {
    return (
        <div className="filters">
            <div className="filters__list">
                {filtersArray.map((filter, idx) => {
                    const classList = new Set([
                        "filters__list-item",
                        filter.isSelected ? "filters__list-item--selected" : ""
                    ]);
                    if (idx <= filtersArray.length - 1 && idx >= filtersArray.length - 3) {
                        classList.add('filters__list-item--no-mb');
                    }
                    return (
                        <button
                            key={idx}
                            onClick={() => toggleFilter(filter.id)}
                            className={Array.from(classList).join(" ")}
                        >
                            {filter.name}
                        </button>
                    );
                })}
            </div>
            <div className="filters__footer">
                {resetFilters && (
                    <Button
                        modifiers={['naked']}
                        onClick={resetFilters}
                    >
                        Reset
                    </Button>
                )}
                {applyFilters && (
                    <Button
                        onClick={applyFilters}
                        isDisabled={!isApplyButtonHighlighted}
                    >
                        Apply
                    </Button>
                )}
            </div>
        </div>
    );
};

Filters.propTypes = {
    filtersArray: PropTypes.array,
    toggleFilter: PropTypes.func,
    applyFilters: PropTypes.func
};

export default Filters;
